const formatCountdownUnits = (totalSeconds, separator) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(separator);
};

export { formatCountdownUnits };

export const formatCountdownTime = (totalSeconds) =>
  formatCountdownUnits(totalSeconds, " | ");

export const formatBannerCountdownTime = (totalSeconds) =>
  formatCountdownUnits(totalSeconds, ":");
